"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.writeGeotiff = void 0;
/*
  Some parts of this file are based on UTIF.js,
  which was released under the MIT License.
  You can view that here:
  https://github.com/photopea/UTIF.js/blob/master/LICENSE
*/

var globals_js_1 = require("./globals.js");

var utils_js_1 = require("./utils.js");

var tagName2Code = (0, utils_js_1.invert)(globals_js_1.fieldTagNames);
var geoKeyName2Code = (0, utils_js_1.invert)(globals_js_1.geoKeyNames);
var name2code = {};
(0, utils_js_1.assign)(name2code, tagName2Code);
(0, utils_js_1.assign)(name2code, geoKeyName2Code);
var typeName2byte = (0, utils_js_1.invert)(globals_js_1.fieldTypeNames); // config variables

var numBytesInIfd = 1000;
var _binBE = {
  nextZero: function nextZero(data, o) {
    var oincr = o;

    while (data[oincr] !== 0) {
      oincr++;
    }

    return oincr;
  },
  readUshort: function readUshort(buff, p) {
    return buff[p] << 8 | buff[p + 1];
  },
  readShort: function readShort(buff, p) {
    var a = _binBE.ui8;
    a[0] = buff[p + 1];
    a[1] = buff[p + 0];
    return _binBE.i16[0];
  },
  readInt: function readInt(buff, p) {
    var a = _binBE.ui8;
    a[0] = buff[p + 3];
    a[1] = buff[p + 2];
    a[2] = buff[p + 1];
    a[3] = buff[p + 0];
    return _binBE.i32[0];
  },
  readUint: function readUint(buff, p) {
    var a = _binBE.ui8;
    a[0] = buff[p + 3];
    a[1] = buff[p + 2];
    a[2] = buff[p + 1];
    a[3] = buff[p + 0];
    return _binBE.ui32[0];
  },
  readASCII: function readASCII(buff, p, l) {
    return l.map(function (i) {
      return String.fromCharCode(buff[p + i]);
    }).join('');
  },
  readFloat: function readFloat(buff, p) {
    var a = _binBE.ui8;
    (0, utils_js_1.times)(4, function (i) {
      a[i] = buff[p + 3 - i];
    });
    return _binBE.fl32[0];
  },
  readDouble: function readDouble(buff, p) {
    var a = _binBE.ui8;
    (0, utils_js_1.times)(8, function (i) {
      a[i] = buff[p + 7 - i];
    });
    return _binBE.fl64[0];
  },
  writeUshort: function writeUshort(buff, p, n) {
    buff[p] = n >> 8 & 255;
    buff[p + 1] = n & 255;
  },
  writeUint: function writeUint(buff, p, n) {
    buff[p] = n >> 24 & 255;
    buff[p + 1] = n >> 16 & 255;
    buff[p + 2] = n >> 8 & 255;
    buff[p + 3] = n >> 0 & 255;
  },
  writeASCII: function writeASCII(buff, p, s) {
    (0, utils_js_1.times)(s.length, function (i) {
      buff[p + i] = s.charCodeAt(i);
    });
  },
  ui8: new Uint8Array(8)
};
_binBE.fl64 = new Float64Array(_binBE.ui8.buffer);

_binBE.writeDouble = function (buff, p, n) {
  _binBE.fl64[0] = n;
  (0, utils_js_1.times)(8, function (i) {
    buff[p + i] = _binBE.ui8[7 - i];
  });
};

var _writeIFD = function _writeIFD(bin, data, _offset, ifd) {
  var offset = _offset;
  var keys = Object.keys(ifd).filter(function (key) {
    return key !== undefined && key !== null && key !== 'undefined';
  });
  bin.writeUshort(data, offset, keys.length);
  offset += 2;
  var eoff = offset + 12 * keys.length + 4;

  var _iterator = _createForOfIteratorHelper(keys),
      _step;

  try {
    var _loop = function _loop() {
      var key = _step.value;
      var tag = null;

      if (typeof key === 'number') {
        tag = key;
      } else if (typeof key === 'string') {
        tag = parseInt(key, 10);
      }

      var typeName = globals_js_1.fieldTagTypes[tag];
      var typeNum = typeName2byte[typeName];

      if (typeName == null || typeName === undefined || typeof typeName === 'undefined') {
        throw new Error("unknown type of tag: ".concat(tag));
      }

      var val = ifd[key];

      if (val === undefined) {
        throw new Error("failed to get value for key ".concat(key));
      } // ASCIIZ format with trailing 0 character
      // http://www.fileformat.info/format/tiff/corion.htm
      // https://stackoverflow.com/questions/7783044/whats-the-difference-between-asciiz-vs-ascii


      if (typeName === 'ASCII' && typeof val === 'string' && (0, utils_js_1.endsWith)(val, "\0") === false) {
        val += "\0";
      }

      var num = val.length;
      bin.writeUshort(data, offset, tag);
      offset += 2;
      bin.writeUshort(data, offset, typeNum);
      offset += 2;
      bin.writeUint(data, offset, num);
      offset += 4;
      var dlen = [-1, 1, 1, 2, 4, 8, 0, 0, 0, 0, 0, 0, 8][typeNum] * num;
      var toff = offset;

      if (dlen > 4) {
        bin.writeUint(data, offset, eoff);
        toff = eoff;
      }

      if (typeName === 'ASCII') {
        bin.writeASCII(data, toff, val);
      } else if (typeName === 'SHORT') {
        (0, utils_js_1.times)(num, function (i) {
          bin.writeUshort(data, toff + 2 * i, val[i]);
        });
      } else if (typeName === 'LONG') {
        (0, utils_js_1.times)(num, function (i) {
          bin.writeUint(data, toff + 4 * i, val[i]);
        });
      } else if (typeName === 'RATIONAL') {
        (0, utils_js_1.times)(num, function (i) {
          bin.writeUint(data, toff + 8 * i, Math.round(val[i] * 10000));
          bin.writeUint(data, toff + 8 * i + 4, 10000);
        });
      } else if (typeName === 'DOUBLE') {
        (0, utils_js_1.times)(num, function (i) {
          bin.writeDouble(data, toff + 8 * i, val[i]);
        });
      }

      if (dlen > 4) {
        dlen += dlen & 1;
        eoff += dlen;
      }

      offset += 4;
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return [offset, eoff];
};

var encodeIfds = function encodeIfds(ifds) {
  var data = new Uint8Array(numBytesInIfd);
  var offset = 4;
  var bin = _binBE; // set big-endian byte-order
  // https://en.wikipedia.org/wiki/TIFF#Byte_order

  data[0] = 77;
  data[1] = 77; // set format-version number
  // https://en.wikipedia.org/wiki/TIFF#Byte_order

  data[3] = 42;
  var ifdo = 8;
  bin.writeUint(data, offset, ifdo);
  offset += 4;
  ifds.forEach(function (ifd, i) {
    var noffs = _writeIFD(bin, data, ifdo, ifd);

    ifdo = noffs[1];

    if (i < ifds.length - 1) {
      bin.writeUint(data, noffs[0], ifdo);
    }
  });

  if (data.slice) {
    return data.slice(0, ifdo).buffer;
  } // node hasn't implemented slice on Uint8Array yet


  var result = new Uint8Array(ifdo);

  for (var i = 0; i < ifdo; i++) {
    result[i] = data[i];
  }

  return result.buffer;
};

var encodeImage = function encodeImage(values, width, height, metadata) {
  if (height === undefined || height === null) {
    throw new Error("you passed into encodeImage a width of type ".concat(height));
  }

  if (width === undefined || width === null) {
    throw new Error("you passed into encodeImage a width of type ".concat(width));
  }

  var ifd = {
    256: [width],
    257: [height],
    273: [numBytesInIfd],
    278: [height],
    305: 'geotiff.js' // no array for ASCII(Z)

  };

  if (metadata) {
    for (var i in metadata) {
      if (metadata.hasOwnProperty(i)) {
        ifd[i] = metadata[i];
      }
    }
  }

  var prfx = new Uint8Array(encodeIfds([ifd]));
  var img = new Uint8Array(values);
  var samplesPerPixel = ifd[277];
  var data = new Uint8Array(numBytesInIfd + width * height * samplesPerPixel);
  (0, utils_js_1.times)(prfx.length, function (i) {
    data[i] = prfx[i];
  });
  (0, utils_js_1.forEach)(img, function (value, i) {
    data[numBytesInIfd + i] = value;
  });
  return data.buffer;
};

var convertToTids = function convertToTids(input) {
  var result = {};

  for (var key in input) {
    if (key !== 'StripOffsets') {
      if (!name2code[key]) {
        console.error(key, 'not in name2code:', Object.keys(name2code));
      }

      result[name2code[key]] = input[key];
    }
  }

  return result;
};

var toArray = function toArray(input) {
  if (Array.isArray(input)) {
    return input;
  }

  return [input];
};

var metadataDefaults = [['Compression', 1], ['PlanarConfiguration', 1], ['ExtraSamples', 0]];

function writeGeotiff(data, metadata) {
  var isFlattened = typeof data[0] === 'number';
  var height;
  var numBands;
  var width;
  var flattenedValues;

  if (isFlattened) {
    height = metadata.height || metadata.ImageLength;
    width = metadata.width || metadata.ImageWidth;
    numBands = data.length / (height * width);
    flattenedValues = data;
  } else {
    numBands = data.length;
    height = data[0].length;
    width = data[0][0].length;
    flattenedValues = [];
    (0, utils_js_1.times)(height, function (rowIndex) {
      (0, utils_js_1.times)(width, function (columnIndex) {
        (0, utils_js_1.times)(numBands, function (bandIndex) {
          flattenedValues.push(data[bandIndex][rowIndex][columnIndex]);
        });
      });
    });
  }

  metadata.ImageLength = height;
  delete metadata.height;
  metadata.ImageWidth = width;
  delete metadata.width; // consult https://www.loc.gov/preservation/digital/formats/content/tiff_tags.shtml

  if (!metadata.BitsPerSample) {
    metadata.BitsPerSample = (0, utils_js_1.times)(numBands, function () {
      return 8;
    });
  }

  metadataDefaults.forEach(function (tag) {
    var key = tag[0];

    if (!metadata[key]) {
      var value = tag[1];
      metadata[key] = value;
    }
  }); // The color space of the image data.
  // 1=black is zero and 2=RGB.

  if (!metadata.PhotometricInterpretation) {
    metadata.PhotometricInterpretation = metadata.BitsPerSample.length === 3 ? 2 : 1;
  } // The number of components per pixel.


  if (!metadata.SamplesPerPixel) {
    metadata.SamplesPerPixel = [numBands];
  }

  if (!metadata.StripByteCounts) {
    // we are only writing one strip
    metadata.StripByteCounts = [numBands * height * width];
  }

  if (!metadata.ModelPixelScale) {
    // assumes raster takes up exactly the whole globe
    metadata.ModelPixelScale = [360 / width, 180 / height, 0];
  }

  if (!metadata.SampleFormat) {
    metadata.SampleFormat = (0, utils_js_1.times)(numBands, function () {
      return 1;
    });
  } // if didn't pass in projection information, assume the popular 4326 "geographic projection"


  if (!metadata.hasOwnProperty('GeographicTypeGeoKey') && !metadata.hasOwnProperty('ProjectedCSTypeGeoKey')) {
    metadata.GeographicTypeGeoKey = 4326;
    metadata.ModelTiepoint = [0, 0, 0, -180, 90, 0]; // raster fits whole globe

    metadata.GeogCitationGeoKey = 'WGS 84';
    metadata.GTModelTypeGeoKey = 2;
  }

  var geoKeys = Object.keys(metadata).filter(function (key) {
    return (0, utils_js_1.endsWith)(key, 'GeoKey');
  }).sort(function (a, b) {
    return name2code[a] - name2code[b];
  });

  if (!metadata.GeoAsciiParams) {
    var geoAsciiParams = '';
    geoKeys.forEach(function (name) {
      var code = Number(name2code[name]);
      var tagType = globals_js_1.fieldTagTypes[code];

      if (tagType === 'ASCII') {
        geoAsciiParams += "".concat(metadata[name].toString(), "\0");
      }
    });

    if (geoAsciiParams.length > 0) {
      metadata.GeoAsciiParams = geoAsciiParams;
    }
  }

  if (!metadata.GeoKeyDirectory) {
    var NumberOfKeys = geoKeys.length;
    var GeoKeyDirectory = [1, 1, 0, NumberOfKeys];
    geoKeys.forEach(function (geoKey) {
      var KeyID = Number(name2code[geoKey]);
      GeoKeyDirectory.push(KeyID);
      var Count;
      var TIFFTagLocation;
      var valueOffset;

      if (globals_js_1.fieldTagTypes[KeyID] === 'SHORT') {
        Count = 1;
        TIFFTagLocation = 0;
        valueOffset = metadata[geoKey];
      } else if (geoKey === 'GeogCitationGeoKey') {
        Count = metadata.GeoAsciiParams.length;
        TIFFTagLocation = Number(name2code.GeoAsciiParams);
        valueOffset = 0;
      } else {
        console.log("[geotiff.js] couldn't get TIFFTagLocation for ".concat(geoKey));
      }

      GeoKeyDirectory.push(TIFFTagLocation);
      GeoKeyDirectory.push(Count);
      GeoKeyDirectory.push(valueOffset);
    });
    metadata.GeoKeyDirectory = GeoKeyDirectory;
  } // delete GeoKeys from metadata, because stored in GeoKeyDirectory tag


  for (var geoKey in geoKeys) {
    if (geoKeys.hasOwnProperty(geoKey)) {
      delete metadata[geoKey];
    }
  }

  ['Compression', 'ExtraSamples', 'GeographicTypeGeoKey', 'GTModelTypeGeoKey', 'GTRasterTypeGeoKey', 'ImageLength', 'ImageWidth', 'Orientation', 'PhotometricInterpretation', 'ProjectedCSTypeGeoKey', 'PlanarConfiguration', 'ResolutionUnit', 'SamplesPerPixel', 'XPosition', 'YPosition'].forEach(function (name) {
    if (metadata[name]) {
      metadata[name] = toArray(metadata[name]);
    }
  });
  var encodedMetadata = convertToTids(metadata);
  var outputImage = encodeImage(flattenedValues, width, height, encodedMetadata);
  return outputImage;
}

exports.writeGeotiff = writeGeotiff;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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